<template>
    <RegularBillingComponent distributorType="0"/>
</template>

<script>
    import RegularBillingComponent from '@/views/Pages/MyPortal/regularBillingComponents/RegularBillingComponent.vue'

    export default {
        components: {
            RegularBillingComponent
        }
    }
</script>